var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.47 11.4197L2.73 9.67969L1 11.4197M19.53 12.5797L21.27 14.3197L23.01 12.5797",
    stroke: "#0061AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.26 14.3202V12.0002C21.26 6.88023 17.11 2.74023 12 2.74023C9.07999 2.74023 6.46999 4.10023 4.76999 6.21023M2.73999 9.68023V12.0002C2.73999 17.1202 6.88999 21.2602 12 21.2602C14.92 21.2602 17.53 19.9002 19.23 17.7902",
    stroke: "#0061AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshBlue);
export default __webpack_public_path__ + "static/media/refresh_blue.01f01bcc1133a5e12a28106af65b6234.svg";
export { ForwardRef as ReactComponent };